import { selectFromProjectDto } from '../../models';

export default selectFromProjectDto()
  .id
  .name
  .createdOn
  .startDate
  .organizationId
  .deleted
  .toString();
